import { type DefaultOptions, QueryClient } from '@tanstack/react-query';

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 60 * 1000,

    gcTime: 5 * 60 * 1000,

    retry: (failureCount, error) => {
      if (error instanceof Error && 'status' in error) {
        const status = (error as any).status;
        if (status >= 400 && status < 500) return false;
      }
      return failureCount < 2;
    },

    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: true,

    throwOnError: false,
  },

  mutations: {
    retry: 1,

    throwOnError: false,
  },
};

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: queryConfig,
  });
